<app-content-header i18n-title title="BL Search" i18n-subTitle
                    subTitle="Filter our SEO BL Pages"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>

<div class="content">

  <div class="row">
    <div class="col-md-3">

      <div class="block">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>
        <div class="block-content block-content-full">
          <form [formGroup]="form">
            <div class="row">

              <div class="col-md-12">

                <div class="form-group row">
                  <label class="col-12" for="keyword">Keyword (Deutsch)</label>
                  <div class="col-md-12">
                    <input type="text" class="form-control" id="keyword" name="keyword"
                           placeholder="keyword"
                           autocomplete="off"
                           formControlName="keyword"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-12" for="destination">Destination (Deutsch)</label>
                  <div class="col-md-12">
                    <input type="text" class="form-control" id="destination" name="destination"
                           placeholder="destination"
                           autocomplete="off"
                           formControlName="destination"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <hr>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="custom-control custom-checkbox custom-control-inline mb-5"
                    >
                      <input class="custom-control-input" type="checkbox" name="isEnabled"
                             id="isEnabled"
                             formControlName="isEnabled">
                      <label class="custom-control-label" for="isEnabled">Is Enabled</label>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">&nbsp;</div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-alt-success" (click)="submitForm()">Submit</button>
              </div>
            </div>

          </form>
        </div>
      </div>

    </div>

    <div class="col-md-9">
      <div class="block" *ngIf="paginationData != null">
        <div class="block-header block-header-default">
          <h3 class="block-title">{{userTotal}} BL Pages</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="table-responsive">
            <table class="table table-striped table-vcenter">
              <thead>
              <tr>
                <th class="text-left">Id</th>
                <th class="text-left">Keyword</th>
                <th class="text-left">Destination</th>
                <th class="text-left">Enabled</th>
                <th class="text-center">Actions</th>
              </tr>
              </thead>
              <tr
                *ngFor="let blPage of blKeywords | paginate: {
              itemsPerPage: paginationData.limit,
              currentPage: paginationData.page,
              totalItems: paginationData.total}"
              >
                <td class="text-left">
                  {{blPage._id}}
                </td>
                <td class="text-left">
                  {{blPage.keywordData.keywordName.de}}
                </td>
                <td class="text-left">
                  {{blPage.destinationData.destinationName.de}}
                </td>
                <td class="text-left">
                  {{blPage.languageVersionEnabled.de}}
                  {{blPage.languageVersionEnabled.en}}
                  {{blPage.languageVersionEnabled['en-gb']}}
                  {{blPage.languageVersionEnabled.es}}
                  {{blPage.languageVersionEnabled.it}}
                </td>
                <td class="text-center">
                  <div class="btn-group">
                    <a class="btn btn-sm btn-primary" href="{{blPage.urls.de}}" target="_blank">DE</a>
                    <a class="btn btn-sm btn-primary" href="{{blPage.urls.en}}" target="_blank">EN</a>
                    <a class="btn btn-sm btn-primary" href="{{blPage.urls['en-gb']}}" target="_blank">ENGB</a>
                    <a class="btn btn-sm btn-primary" href="{{blPage.urls.es}}" target="_blank">ES</a>
                    <a class="btn btn-sm btn-primary" href="{{blPage.urls.it}}" target="_blank">IT</a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="block-content block-content-full block-content-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
          ></pagination-controls>
        </div>
      </div>


    </div>


  </div>

</div>
